WiseMetering.Views.DisableIntegrationConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/disable',
    title: () => i18next.t('modal.title.integration_configurations.disable'),
    warning: null,

    save: function() {
        const comment = (this.getFormData().comment || '').trim();

        if (!comment) {
            this.showCommentError(i18next.t('integration_configurations.disable_reason_required'));
            return;
        }

        this.showCommentError(null);
        this.modal.block();

        this.model.disable(comment, {
            success: function() {
                WiseMetering.integrationConfigurations.fetch();
                WiseMetering.layout.showTipper('success', i18next.t('ui.successfully_saved'));
                this.modal.close();
            }.bind(this),
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON?.error || i18next.t('ui.unspecified_error');
                WiseMetering.layout.showTipper('error', errorMessage);
                this.modal.unblock();
            }.bind(this)
        });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            warning: this.warning
        };
    },

    showCommentError: function(message) {
        const $errors = $(this.modal.errors.el);

        this.$(`label[for='${this.form_prefix}_comment']`).toggleClass('err', Boolean(message));

        if (!message) {
            $errors.removeClass('active').empty();
            return;
        }

        $errors.addClass('active').text(message);
    }
});
